class JsonLd {
    constructor(status, selectors, debug = true) {

        this.status = document.querySelector(status);

        if (this.status) {
            let defaultSelectors = {
                name: ".name-json-ld",
                description: ".description-json-ld",
                contacts: ".contacts-json-ld",
                mail: ".mail-json-ld",
                price: ".price-json-ld",
                url: ".url-json-ld",
                image: ".image-json-ld",
                brand: ".brand-json-ld",
            }

            this.selectors = Object.assign(defaultSelectors, selectors);

            this.event();

            if (debug) this.dbg(this.jsonLd);

        }
    }

    event = () => {
        this.jsonLd = {};

        switch (this.status.dataset.jsonLd) {
            case 'product':
                this.product();
                break;

            case 'category':
                this.category();
                break;

            case 'home':
                this.home();
                break;
        }

        this.add();
    }

    home = () => {
        const name = document.querySelector('title');
        const image = document.querySelector(this.selectors.image);
        const description = document.querySelector('meta[name=description]');
        const url = image.closest('a').href;

        const contactPoint = []
        document.querySelectorAll(this.selectors.contacts + ' li').forEach((el) => {
            if (el.dataset.phoneJsonLd) {
                contactPoint.push(
                    {
                        "@type": "ContactPoint",
                        "telephone": el.dataset.phoneJsonLd,
                        "contactType": el.dataset.contactTypeJsonLd,
                        "contactOption": "TollFree",
                        "areaServed": ["UA"],
                        "availableLanguage": ["Ukraine"]
                    }
                );
            } else {
                contactPoint.push(
                    {
                        "@type": "ContactPoint",
                        "url": el.dataset.urlJsonLd,
                        "contactType": el.dataset.contactTypeJsonLd,
                        "areaServed": ["UA"],
                        "availableLanguage": ["Ukraine"]
                    }
                );
            }
        });

        const mail = document.querySelector(this.selectors.mail + ' li a');
        // @TODO hours-json-ld

        this.jsonLd = {
            "@context": "https://schema.org",
            "@graph": [
                {
                    "@type": "Organization",
                    "name": name.textContent,
                    "url": url,
                    "legalName": "FastService",
                    "alternateName": "Fastservice",
                    "foundingDate": "2013",
                    "email": mail.href,
                    "contactPoint": contactPoint,
                    "logo": {
                        "@type": "ImageObject",
                        "@id": url,
                        "url": image.src,
                        "caption": "WhiteBIT - Cryptocurrency Exchange"
                    },
                    "founders": [
                        {
                            "@type": "Person",
                            "name": "Andrey Petrenko"
                        }
                    ],
                    "sameAs": [
                        "https://t.me/fastserviceua"
                    ]
                },
                {
                    "@type": "ImageObject",
                    "@id": url + "#og-image",
                    "url": image.src,
                    "width": 385,
                    "height": 80
                },
                {
                    "@type": "WebPage",
                    "@id": url,
                    "url": url,
                    "inLanguage": "UA",
                    "name": name.textContent,
                    "description": description.content
                },
            ],

        }
    }

    product = () => {

        const stock = [
            "InStock",
            "OutOfStock",
            "PreOrder"
        ];

        const name = document.querySelector('title');
        const description = document.querySelector('meta[name=description]');

        const price = this.status.querySelector(this.selectors.price).textContent.split(' ');

        const images = this.status.querySelectorAll(this.selectors.image);

        const brand = this.status.querySelector(this.selectors.brand);

        this.jsonLd = {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": name.textContent,
            "description": description.content ? description.content : name.textContent,
            "url": this.status.querySelector(this.selectors.url).dataset.jsonLdUrl,
            "image": images[0].src,
            // "image": Array.from(this.status.querySelectorAll(this.selectors.image), (el) => el.src),
            "brand": brand ? brand.textContent : name.textContent,
            "offers": 
                {
                    "@type": "Offer",
                    "price": price[0],
                    "priceCurrency": price[1],
                    "availability": "https://schema.org/" + stock[0]
                }

        }
    }

    category = () => {
        const offers = [];
        this.status.querySelectorAll(this.selectors.price).forEach((el) => {
            const price = el.textContent.split(' ')
            offers.push(
                {
                    "@type": "Offer",
                    "price": price[0],
                    "priceCurrency": price[1]
                }
            );
        });

        const itemListElement = [];
        this.status.querySelectorAll(this.selectors.image).forEach((el, index) => {
            itemListElement.push(
                {
                    "@type": "Product",
                    "url": el.closest('a').href,
                    "name": el.title,
                    "image": el.src,
                    "offers": offers[index]
                }
            );
        });

        this.jsonLd = {
            "@context": "https://schema.org",
            "@type": "ItemList",
            "url": this.status.querySelector(this.selectors.url).href,
            "numberOfItems": itemListElement.length,
            "itemListElement": itemListElement
        }
    }

    add = () => {
        document.querySelector('head').insertAdjacentHTML('beforeend',
            `<script type="application/ld+json">${JSON.stringify(this.jsonLd)}</script>`);
    }

    dbg = (data) => {
        console.log(JSON.stringify(data, null, 4));
    }
}
